import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import MapProps from './MapProps'
import KendoMapMarker from '../KendoMapMarker'
import KendoMapLayer from '../KendoMapLayer'

import Controls from './Controls'
import LayerDefaults from './LayerDefaults'
import MarkerDefaults from './MarkerDefaults'

export default {
    props: MapProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent,
        Controls,
        LayerDefaults,
        MarkerDefaults
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoMap(this.widgetOptions)

        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoMap()
        },
        _resolveChildren() {
            this.resolveChildren('markers', KendoMapMarker.name)
            this.resolveChildren('layers', KendoMapLayer.name)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMap/KendoMapMixin.js